import React from 'react';
import {Link} from "react-router-dom";
import Header from "../../header/header";
import {authenticationService} from "../../scripts/authentication.service";
import { CSVReader, CSVDownloader } from 'react-papaparse';
import {Button, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {cf} from "../../scripts/custom-fetch";
import {withCompanyScope} from "../../scripts/companyScope";
import {withSnackbar} from "notistack";

const fileNames = {
    content: {
        shortName: 'mcw-1.2',
        longName: 'LS - Main Content - v1.2',
        displayName: 'Main Content - v1.2'
    },
    contentPersona: {
        shortName: 'mcp-1.2',
        longName: 'LS - Main Content With Persona - v1.2',
        displayName: 'Main Content With Persona - v1.2'
    },
    stims: {
        shortName: 'msw-1.3',
        longName: 'LS - Main Sponsored Content - v1.3',
        displayName: 'Main Sponsored Content - v1.3'
    },
    stimsPersona: {
        shortName: 'msp-1.3',
        longName: 'LS - Main Sponsored With Persona - v1.3',
        displayName: 'Main Sponsored With Persona - v1.3'
    },
    story: {
        shortName: 'stw-1.2',
        longName: 'LS - Story Content - v1.2',
        displayName: 'Story Content - v1.2'
    },
    storyPersona: {
        shortName: 'stp-1.2',
        longName: 'LS - Story Content With Persona - v1.2',
        displayName: 'Story Content With Persona - v1.2'
    },
    reel: {
        shortName: 'rcw-1.0',
        longName: 'LS - Reel Content - v1.0',
        displayName: 'Reel Content - v1.0'
    },
    reelPersona: {
        shortName: 'rcp-1.0',
        longName: 'LS - Reel Content With Persona - v1.0',
        displayName: 'Reel Content With Persona - v1.0'
    },
    reelStim: {
        shortName: 'rsw-1.0',
        longName: 'LS - Reel Stim - v1.0',
        displayName: 'Reel Stim - v1.0'
    },
    reelStimPersona: {
        shortName: 'rsp-1.0',
        longName: 'LS - Reel Stim With Persona - v1.1',
        displayName: 'Reel Stim With Persona - v1.1'
    },
    music: {
        shortName: 'mmw-1.0',
        longName: 'LS - Music Content - v1.0',
        displayName: 'Music Content - v1.0'
    },
    musicPlaylist: {
        shortName: 'mmp-1.0',
        longName: 'LS - Music Content With Playlist - v1.0',
        displayName: 'Music Content With Playlist - v1.0'
    },
    musicStim: {
        shortName: 'mpw-1.0',
        longName: 'LS - Music Sponsored Content - v1.0',
        displayName: 'Music Sponsored Content - v1.0'
    },
    musicStimPersona: {
        shortName: 'mpp-1.0',
        longName: 'LS - Music Sponsored Content With Playlist - v1.0',
        displayName: 'Music Sponsored Content With Playlist - v1.0'
    },
    video: {
        shortName: 'vdw-1.0',
        longName: 'LS - Video Content - v1.0',
        displayName: 'Video Content - v1.0'
    },
    videoPlaylist: {
        shortName: 'vdp-1.0',
        longName: 'LS - Video Content With Playlist - v1.0',
        displayName: 'Video Content With Playlist - v1.0'
    },
    videoStim: {
        shortName: 'vsw-1.0',
        longName: 'LS - Video Sponsored Content - v1.0',
        displayName: 'Video Sponsored Content - v1.0'
    },
    videoStimPersona: {
        shortName: 'vsp-1.0',
        longName: 'LS - Video Sponsored Content With Playlist - v1.0',
        displayName: 'Video Sponsored Content With Playlist - v1.0'
    },
}

class Import extends React.Component {
    constructor(props) {
        super(props);

        this.handleRemove = this.handleRemove.bind(this);
        this.import = this.import.bind(this);
        this.checkInfo = this.checkInfo.bind(this);

        this.state = {
            error: null,
            isSending: true,
            response: [],
            msg: "",
            data: [],
            currentUser: authenticationService.currentUserValue,
            type: "content",
        };
    }

    checkInfo() {
        this.props.enqueueSnackbar('Checking Data', {variant:"info"});
        let data = this.state.data[0]
        switch (this.state.type){
            case "content":
                if (data.data.file === fileNames.content.shortName || data.data.file === fileNames.contentPersona.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "stim":
                if (data.data.file === fileNames.stims.shortName || data.data.file === fileNames.stimsPersona.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "story":
                if (data.data.file === fileNames.story.shortName || data.data.file === fileNames.storyPersona.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "watch":
                if (data.data.file === fileNames.content.shortName || data.data.file === fileNames.contentPersona.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "watchStim":
                if (data.data.file === fileNames.content.shortName || data.data.file === fileNames.contentPersona.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "reel":
                if (data.data.file === fileNames.reel.shortName || data.data.file === fileNames.reelPersona.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "reelStim":
                if (data.data.file === fileNames.reelStim.shortName || data.data.file === fileNames.reelStimPersona.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "music":
                if (data.data.file === fileNames.music.shortName || data.data.file === fileNames.musicPlaylist.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "musicStim":
                if (data.data.file === fileNames.musicStim.shortName || data.data.file === fileNames.musicStimPersona.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "video":
                if (data.data.file === fileNames.video.shortName || data.data.file === fileNames.videoPlaylist.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            case "videoStim":
                if (data.data.file === fileNames.videoStim.shortName || data.data.file === fileNames.videoStimPersona.shortName) {
                    this.import()
                } else {
                    this.props.enqueueSnackbar('Incorrect Type Selected', {variant:"error"});
                }
                break;
            default:
                this.props.enqueueSnackbar('Type out of bounds contact admin', {variant:"error"});
                break;
        }
    }

    import() {
        this.props.enqueueSnackbar('Importing', {variant:"info"});
        this.setState({
            isSending: true
        }, () => {
            const options = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
                body: JSON.stringify({
                    'data': this.state.data,
                    'type': this.state.type
                })
            };

            cf.get(withCompanyScope(`${process.env.REACT_APP_API_POST}/import/import`), options)
                .then((result) => {
                        console.log(result)
                        if (result.result.contentFailed.length > 0 || result.result.linkingFailed.length > 0 || result.result.profilesFailed.length > 0) {
                            this.props.enqueueSnackbar('Saved with errors see below', {variant:"warning"});
                        } else {
                            this.props.enqueueSnackbar('Saved', {variant:"success"});
                        }
                        this.setState({
                            response: result.result,
                            isSending: false,
                        })
                    },
                    (error) => {
                        console.log(error)
                        this.props.enqueueSnackbar('Save Failed - Please Contact an Admin', {variant:"error"});
                    }
                )
        })
    }

    handleDrop = (data) => {
        console.log(data);
        this.setState({
            data: data,
            isSending: false,
        })
    }

    handleErr(err, file, inputElem, reason) {
        console.log(err);
    }

    handleRemove(data) {
        console.log(data);
        this.setState({
            data: data,
            isSending: true
        })
    }

    selectImportType = (event) => {
        this.setState({type: event.target.value})
    }

    render() {
        const { error, isSending, type, response } = this.state;
        console.log(response)
        if (error) {
            return <div>Error: {error.message}</div>;
        } else {
            return (
                <>
                    <Header/>
                    <div className="social">
                        <div className="box post-edit" style={{alignItems: "flex-start"}}>
                            <div className="post-panel" style={{width:"400px"}}>
                                <div id="CONTENT">
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Feed Item",
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "location": "London",
                                                    "comments": "12",
                                                    "likes": "52",
                                                    "shares": "1",
                                                    "postedOn": "2d",
                                                    "viewabilityTracking": false,
                                                    "like": true,
                                                    "love": false,
                                                    "haha": true,
                                                    "wow": false,
                                                    "sad": false,
                                                    "angry": false,
                                                    "langId": 1,
                                                    "file": fileNames.content.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.content.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.content.displayName}</Button>
                                    </CSVDownloader>
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Feed Item",
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "location": "London",
                                                    "comments": "12",
                                                    "likes": "52",
                                                    "shares": "1",
                                                    "postedOn": "2d",
                                                    "viewabilityTracking": false,
                                                    "persona": 14,
                                                    "order": 1,
                                                    "like": true,
                                                    "love": false,
                                                    "haha": true,
                                                    "wow": false,
                                                    "sad": false,
                                                    "angry": false,
                                                    "langId": 1,
                                                    "file": fileNames.contentPersona.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.contentPersona.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.contentPersona.displayName}</Button>
                                    </CSVDownloader>
                                </div>
                                <div id="ADS">
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example AD Item",
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "promoDesc": "Example AD Desc",
                                                    "promoDesc2": "Example AD Desc 2",
                                                    "promoLink": "www.example.com",
                                                    "promoButton": "Shop Now",
                                                    "location": "Sponsored",
                                                    "comments": "12",
                                                    "likes": "52",
                                                    "shares": "1",
                                                    "postedOn": "Sponsored",
                                                    "promoted": true,
                                                    "viewabilityTracking": true,
                                                    "like": true,
                                                    "love": false,
                                                    "haha": true,
                                                    "wow": false,
                                                    "sad": false,
                                                    "angry": false,
                                                    "langId": 1,
                                                    "file": fileNames.stims.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.stims.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.stims.displayName}</Button>
                                    </CSVDownloader>
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example AD Item",
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "promoDesc": "Example AD Desc",
                                                    "promoDesc2": "Example AD Desc 2",
                                                    "promoLink": "www.example.com",
                                                    "promoButton": "Shop Now",
                                                    "location": "Sponsored",
                                                    "comments": "12",
                                                    "likes": "52",
                                                    "shares": "1",
                                                    "postedOn": "Sponsored",
                                                    "promoted": true,
                                                    "viewabilityTracking": true,
                                                    "persona": 14,
                                                    "order": 1,
                                                    "like": true,
                                                    "love": false,
                                                    "haha": true,
                                                    "wow": false,
                                                    "sad": false,
                                                    "angry": false,
                                                    "langId": 1,
                                                    "file": fileNames.stimsPersona.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.stimsPersona.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.stimsPersona.displayName}</Button>
                                    </CSVDownloader>
                                </div>
                                <div id="STORY">
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "cover": "https://i.imgur.com/PJ79wPV.png",
                                                    "cta": "Shop Now",
                                                    "link": "www.example.com",
                                                    "postedOn": "Sponsored",
                                                    "promoted": false,
                                                    "viewabilityTracking": false,
                                                    "langId": 1,
                                                    "file": fileNames.story.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.story.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.story.displayName}</Button>
                                    </CSVDownloader>
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "cover": "https://i.imgur.com/PJ79wPV.png",
                                                    "cta": "Shop Now",
                                                    "link": "www.example.com",
                                                    "postedOn": "Sponsored",
                                                    "promoted": false,
                                                    "viewabilityTracking": false,
                                                    "langId": 1,
                                                    "persona": 14,
                                                    "order": 1,
                                                    "file": fileNames.storyPersona.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.storyPersona.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.storyPersona.displayName}</Button>
                                    </CSVDownloader>
                                </div>
                                <div id="REEL">
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Desc",
                                                    "coverText": "Wow Great Snap",
                                                    "coverSrc": "https://i.imgur.com/PJ79wPV.png",
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "song": "Everybody Needs Somebody to Love",
                                                    "comments": "12",
                                                    "likes": "122",
                                                    "shares": "13",
                                                    "langId": 1,
                                                    "file": fileNames.reel.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.reel.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.reel.displayName}</Button>
                                    </CSVDownloader>
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Desc",
                                                    "coverText": "Wow Great Snap",
                                                    "coverSrc": "https://i.imgur.com/PJ79wPV.png",
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "song": "Everybody Needs Somebody to Love",
                                                    "comments": "12",
                                                    "likes": "122",
                                                    "shares": "13",
                                                    "langId": 1,
                                                    "persona": 14,
                                                    "order": 1,
                                                    "file": fileNames.reelPersona.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.reelPersona.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.reelPersona.displayName}</Button>
                                    </CSVDownloader>
                                </div>
                                <div id="REEL STIM">
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Desc",
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "song": "Everybody Needs Somebody to Love",
                                                    "comments": "12",
                                                    "likes": "122",
                                                    "shares": "13",
                                                    "promoA":"Promo Text",
                                                    "promoB":"Promo Button / CTA",
                                                    "promoC":"Promo Card / Promo Top",
                                                    "promoD":"Promo Card Title / Promo Desc",
                                                    "promoE":"Promo Rating",
                                                    "skipTime": 5,
                                                    "skippable": false,
                                                    "sound": false,
                                                    "langId": 1,
                                                    "file": fileNames.reelStim.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.reelStim.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.reelStim.displayName}</Button>
                                    </CSVDownloader>
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Desc",
                                                    "src": "https://i.imgur.com/PJ79wPV.png",
                                                    "song": "Everybody Needs Somebody to Love",
                                                    "comments": "12",
                                                    "likes": "122",
                                                    "shares": "13",
                                                    "promoA":"Promo Text",
                                                    "promoB":"Promo Button / CTA",
                                                    "promoC":"Promo Card / Promo Top",
                                                    "promoD":"Promo Card Title / Promo Desc",
                                                    "promoE":"Promo Rating",
                                                    "skipTime": 5,
                                                    "skippable": false,
                                                    "sound": false,
                                                    "langId": 1,
                                                    "persona": 14,
                                                    "order": 1,
                                                    "file": fileNames.reelStimPersona.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.reelStimPersona.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.reelStimPersona.displayName}</Button>
                                    </CSVDownloader>
                                </div>
                                <div id="MUSIC">
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "songName": "Merry-Go-Round",
                                                    "author": "MAN WITH A MISSION",
                                                    "song": "https://content.lumen-research.com/look-a-like-music/JRock/Merry-Go-Round.mp3",
                                                    "src": "https://i.imgur.com/qgqzZAt.png",
                                                    "langId": 1,
                                                    "file": fileNames.music.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.music.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.music.displayName}</Button>
                                    </CSVDownloader>
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "songName": "Merry-Go-Round",
                                                    "author": "MAN WITH A MISSION",
                                                    "song": "https://content.lumen-research.com/look-a-like-music/JRock/Merry-Go-Round.mp3",
                                                    "src": "https://i.imgur.com/qgqzZAt.png",
                                                    "langId": 1,
                                                    "playlist": 1,
                                                    "order": 1,
                                                    "file": fileNames.musicPlaylist.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.musicPlaylist.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.musicPlaylist.displayName}</Button>
                                    </CSVDownloader>
                                </div>
                                <div id="MUSIC AD">
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "promoText": "Wow so Cool",
                                                    "promoText2": "Its an ad jimmy",
                                                    "song": "https://content.lumen-research.com/look-a-like-music/JRock/Merry-Go-Round.mp3",
                                                    "src": "https://i.imgur.com/qgqzZAt.png",
                                                    "langId": 1,
                                                    "file": fileNames.musicStim.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.musicStim.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.musicStim.displayName}</Button>
                                    </CSVDownloader>
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "promoText": "Wow so Cool",
                                                    "promoText2": "Its an ad jimmy",
                                                    "song": "https://content.lumen-research.com/look-a-like-music/JRock/Merry-Go-Round.mp3",
                                                    "src": "https://i.imgur.com/qgqzZAt.png",
                                                    "langId": 1,
                                                    "persona": 1,
                                                    "order": 1,
                                                    "file": fileNames.musicStimPersona.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.musicStimPersona.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.musicStimPersona.displayName}</Button>
                                    </CSVDownloader>
                                </div>
                                <div id="VIDEO">
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Desc",
                                                    "src": "https://i.imgur.com/qgqzZAt.png",
                                                    "coverSrc": "https://i.imgur.com/qgqzZAt.png",
                                                    "text1": "Video Text 1",
                                                    "text2": "Video Text 2",
                                                    "text3": "Video Text 3",
                                                    "text4": "Video Text 4",
                                                    "comments": 1,
                                                    "likes": 1,
                                                    "views": 1,
                                                    "row": 1,
                                                    "postedOn": "2 days ago",
                                                    "muted": false,
                                                    "viewabilityTracking": false,
                                                    "langId": 1,
                                                    "file": fileNames.video.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.video.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.video.displayName}</Button>
                                    </CSVDownloader>
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Desc",
                                                    "src": "https://i.imgur.com/qgqzZAt.png",
                                                    "coverSrc": "https://i.imgur.com/qgqzZAt.png",
                                                    "text1": "Video Text 1",
                                                    "text2": "Video Text 2",
                                                    "text3": "Video Text 3",
                                                    "text4": "Video Text 4",
                                                    "comments": 1,
                                                    "likes": 1,
                                                    "views": 1,
                                                    "row": 1,
                                                    "postedOn": "2 days ago",
                                                    "muted": false,
                                                    "viewabilityTracking": false,
                                                    "playlist": 1,
                                                    "order": 1,
                                                    "langId": 1,
                                                    "file": fileNames.videoPlaylist.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.videoPlaylist.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.videoPlaylist.displayName}</Button>
                                    </CSVDownloader>
                                </div>
                                <div id="VIDEO AD">
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Desc",
                                                    "src": "https://i.imgur.com/qgqzZAt.png",
                                                    "coverSrc": "https://i.imgur.com/qgqzZAt.png",
                                                    "text1": "Video Text 1",
                                                    "text2": "Video Text 2",
                                                    "text3": "Video Text 3",
                                                    "text4": "Video Text 4",
                                                    "type": 1,
                                                    "time": 1,
                                                    "skippable": 1,
                                                    "muted": 1,
                                                    "viewabilityTracking": 1,
                                                    "langId": 1,
                                                    "file": fileNames.videoStim.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.videoStim.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.videoStim.displayName}</Button>
                                    </CSVDownloader>
                                    <CSVDownloader
                                        data={() => {
                                            return [
                                                {
                                                    "title": "Example",
                                                    "name": "Steve",
                                                    "pic": "https://i.imgur.com/I6m9rKK.png",
                                                    "verified": false,
                                                    "company": false,
                                                    "desc": "Example Desc",
                                                    "src": "https://i.imgur.com/qgqzZAt.png",
                                                    "coverSrc": "https://i.imgur.com/qgqzZAt.png",
                                                    "text1": "Video Text 1",
                                                    "text2": "Video Text 2",
                                                    "text3": "Video Text 3",
                                                    "text4": "Video Text 4",
                                                    "type": 1,
                                                    "time": 1,
                                                    "skippable": 1,
                                                    "muted": 1,
                                                    "viewabilityTracking": 1,
                                                    "persona": 1,
                                                    "order": 1,
                                                    "langId": 1,
                                                    "file": fileNames.videoStimPersona.shortName
                                                }
                                            ]}
                                        }
                                        filename={fileNames.videoStimPersona.longName}
                                        type={'link'}
                                    >
                                        <Button style={{marginBottom: "10px", width: "100%"}} variant="contained">{fileNames.videoStimPersona.displayName}</Button>
                                    </CSVDownloader>
                                </div>
                            </div>
                            <div className="import">
                                <FormControl style={{marginBottom:"20px", width:"100%"}} variant="outlined">
                                    <InputLabel>Type</InputLabel>
                                    <Select
                                        value={type}
                                        onChange={this.selectImportType}
                                        label="Type"
                                    >
                                        <MenuItem value={"content"}>Main Content</MenuItem>
                                        <MenuItem value={"stim"}>Main Sponsored</MenuItem>
                                        <MenuItem value={"story"}>Story Content/Sponsored</MenuItem>
                                        <MenuItem value={"watch"}>Watch Content</MenuItem>
                                        <MenuItem value={"watchStim"}>Watch Sponsored</MenuItem>
                                        <MenuItem value={"reel"}>Reel Content</MenuItem>
                                        <MenuItem value={"reelStim"}>Reel Sponsored</MenuItem>
                                        <MenuItem value={"music"}>Music Content</MenuItem>
                                        <MenuItem value={"musicStim"}>Music Sponsored</MenuItem>
                                        <MenuItem value={"video"}>Video Content</MenuItem>
                                        <MenuItem value={"videoStim"}>Video Sponsored</MenuItem>
                                    </Select>
                                </FormControl>
                                <CSVReader
                                    onDrop={this.handleDrop}
                                    onError={this.handleErr}
                                    onRemoveFile={this.handleRemove}
                                    addRemoveButton
                                    config={{
                                        header: true,
                                        skipEmptyLines: true,
                                        transform: ( test => {return test.replace(/TRUE/g, "1").replace(/FALSE/g, "0").replace(/true/g, "1").replace(/false/g, "0")} ),
                                    }}
                                    style={{
                                        dropFile: {
                                            width: 200,
                                            height: "100%",
                                            color: "black"
                                        }
                                    }}
                                >
                                    <span>Drop CSV file here or click to upload.</span>
                                </CSVReader>

                                <div className="errors">
                                    {(response.profilesFailed) && (
                                        <div>
                                            <div className="titles">Profiles Failed: {response.profilesFailed.length}</div>
                                            {response.profilesFailed.map((item) => (
                                                <div className="error-item">{JSON.stringify(item,null, 1)}</div>
                                            ))}
                                        </div>
                                    )}
                                    {(response.contentFailed) && (
                                        <div>
                                            <div className="titles">Content Failed: {response.contentFailed.length}</div>
                                            {response.contentFailed.map((item) => (
                                                <div className="error-item">{JSON.stringify(item,null, 1)}</div>
                                            ))}
                                        </div>
                                    )}
                                    {(response.linkingFailed) && (
                                        <div>
                                            <div className="titles">Linking Failed: {response.linkingFailed.length}</div>
                                            {response.linkingFailed.map((item) => (
                                                <div className="error-item">{JSON.stringify(item,null, 1)}</div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div style={{width:"400px"}} />
                        </div>
                        <div className="links">
                            <Button variant="contained" className="spacer" disabled={isSending} onClick={this.checkInfo}>Import</Button>
                            <Button variant="contained"><Link to="/content">Back</Link></Button>
                        </div>
                    </div>
                </>
            );
        }
    }
}

export default withSnackbar(Import);
